import BaseService from '@/services/BaseService'

class PermissaoService extends BaseService {
    constructor(){
        super('/v1/permissoes')
    }
}

export default new PermissaoService